import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { customerUsersContext } from './CustomerUsersContext';
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";


let CustomerUsers = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customerUsersContext);


    return (
        <>
            <PageHeader pageTitle={formatMessage({ id: LocalizationIds.Users })} addNewUrl={`/customer/user/addnew/`} />
            <Filter />
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default CustomerUsers;